import styled from '@emotion/styled';
import { css } from '@emotion/react';

import { Box } from '@toolbox/components';
import { makeStyles } from '@toolbox/style';
import { RadioCard, RadioGroupField } from '../../components';

import type { ReactFCWithChildren } from '@widget/types/ReactFCWithChildren';
import type { QuestionStepOptionListProps } from './QuestionStep';

const Grid = styled(Box)<{ size: number }>`
  display: grid;
  grid-template-columns: ${(props) =>
    props.size == 4
      ? 'calc(25% - 6px) calc(25% - 6px) calc(25% - 6px) calc(25% - 6px)'
      : props.size == 3
      ? 'calc(33% - 6px) calc(33% - 6px) calc(33% - 6px)'
      : 'calc(50% - 6px) calc(50% - 6px)'};
  column-gap: ${(props) => (props.size == 4 ? '8px' : '12px')};
  row-gap: 12px;
`;

const useStyles = makeStyles(({ theme }) => ({
  grid: css`
    ${theme.media.down('sm')} {
      display: grid;
      grid-template-columns: calc(50% - 6px) calc(50% - 6px);
      column-gap: 12px;
      row-gap: 12px;
    }
  `,
}));

export const QuestionStepOptionListV3: ReactFCWithChildren<QuestionStepOptionListProps> = ({
  name,
  optionList,
  gridSize,
  valueType,
}) => {
  const classes = useStyles();
  return (
    <RadioGroupField name={name}>
      <Grid size={gridSize || 3} css={classes.grid as any}>
        {optionList.map((radioProps) => {
          return (
            <RadioCard
              key={radioProps.value}
              {...radioProps}
              value={valueType == 'number' ? Number(radioProps.value) : radioProps.value}
              submit
            />
          );
        })}
      </Grid>
    </RadioGroupField>
  );
};
